export default "__VITE_ASSET__BGW8oZif__"